import { trainLength, type Vehicle } from '@rcs/data-schema';
import type { VehicleModelSpec } from '@rcs/renderer';

/** 車両（保存データの形式）から、3D のモデルの仕様を作る。 */
export function toVehicleModelSpec(vehicle: Vehicle): VehicleModelSpec {
  return {
    model: vehicle.appearance.model,
    carCount: vehicle.carCount,
    carLength: vehicle.carLength,
    carSpacing: vehicle.carSpacing,
    width: vehicle.width,
    height: vehicle.height,
    seatsPerCar: vehicle.seatsPerCar,
    occupancy: vehicle.occupancy,
    color: Number.parseInt(vehicle.appearance.color.slice(1), 16),
  };
}

/** 車両の要点（画面の説明用）：総質量 [t]・全長 [m]・最高速度 [km/h]・定員 [人]。 */
export function vehicleFacts(
  vehicle: Vehicle,
  totalMassKg: number,
): { massTons: number; lengthMeters: number; maxSpeedKmh: number; capacity: number } {
  return {
    massTons: totalMassKg / 1000,
    lengthMeters: trainLength(vehicle),
    maxSpeedKmh: vehicle.limits.maxSpeed * 3.6,
    capacity: vehicle.carCount * vehicle.seatsPerCar,
  };
}
